const rides = [
    {
        id: 1,
        title: 'Bike',
        imgUrl: 'https://images.carandbike.com/bike-images/medium/jawa/42/jawa-42.webp?v=5',
        capacity: 1,
        price: 119
    },
    {
        id: 2,
        title: 'Car',
        imgUrl: 'https://cdni.autocarindia.com/Utils/ImageResizer.ashx?n=http%3A%2F%2Fcms.haymarketindia.net%2Fmodel%2Fuploads%2Fmodelimages%2FHuracanModelImage.jpg&h=300&w=450&q=100',
        capacity: 4,
        price: 249
    },
    {
        id: 3,
        title: 'Bus',
        imgUrl: 'https://www.charterbus-limousine.com/img/cartype/small.jpg',
        capacity: 25,
        price: 50
    },
    {
        id: 4,
        title: 'Train',
        imgUrl: 'https://www.mid-9.com/1m-tomytec/image/218210.jpg',
        capacity: 400,
        price: 249
    }
]
export default rides;